import React from "react";
import "./Archive.scss";
import specialOffersDoc from "@assets/documents/10_09_2024_МФО_PAYLATER_Маркетинговая_акция v2.pdf";
import mfoOfertaOld1 from "@assets/documents/30_04_2026_MFO_OFERTA.pdf";
import paylaterFinanceOldRu from "@assets/documents/9_07_2026_PAYLATER_FINANCE_RU.docx";
import paylaterFinanceOldUz from "@assets/documents/9_07_2026_PAYLATER_FINANCE_UZ.docx";
import pdfIcon from "@assets/img/pdf_icon.svg";
import wordIcon from "@assets/img/word_icon.svg";
import { useTranslation } from "react-i18next";

const documents = [
  {
    id: 1,
    fileUrl: specialOffersDoc,
    titleKey: "archive.subtitle1",
    descKey: "archive.description1",
  },
  {
    id: 2,
    fileUrl: mfoOfertaOld1,
    titleKey: "archive.subtitle2",
    descKey: "archive.description2",
    timeEnd: "30.04.2026",
  },
  {
    id: 3,
    fileUrl: paylaterFinanceOldRu,
    fileType: "docx",
    titleKey: "archive.subtitle3",
    descKey: "archive.description3",
    timeEnd: "31.05.2026",
  },
  {
    id: 4,
    fileUrl: paylaterFinanceOldUz,
    fileType: "docx",
    titleKey: "archive.subtitle4",
    descKey: "archive.description4",
    timeEnd: "31.05.2026",
  },
];

const Archive = () => {
  const { t: tCommon } = useTranslation(["common"]);

  return (
    <div className="archive">
      <h1 className="archive__title">{tCommon("archive.title")}</h1>

      <div className="archive__grid">
        {documents.map((doc) => (
          <a
            key={doc.id}
            className="archive__card"
            href={doc.fileUrl}
            target="_blank"
            rel="noreferrer"
          >
            {doc.timeEnd && (
              <div className="archive__card-badge">
                <span className="archive__card-badge-label">
                  {tCommon("archive.timeEnd")}
                </span>
                <span className="archive__card-badge-date">{doc.timeEnd}</span>
              </div>
            )}
            <img
              className="archive__icon"
              src={doc.fileType === "docx" ? wordIcon : pdfIcon}
              alt={doc.fileType === "docx" ? "word icon" : "pdf icon"}
            />

            <h3 className="archive__card-title">{tCommon(doc.titleKey)}</h3>

            <p className="archive__card-desc">{tCommon(doc.descKey)}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Archive;
